import { openWebBrowserURL } from '@/utils/navigation';

export const PMC_PAYMENTS_URL = 'https://suppliers.usepepper.com/payments';

export const openPmcPayments = (): Promise<void> =>
  openWebBrowserURL(() => Promise.resolve(PMC_PAYMENTS_URL));
